import { createSlice } from '@reduxjs/toolkit';

export const FJSliceObjectErase = createSlice({
    name: 'objectErase',
    initialState: {
        inputImageInfo: null,
    },
    reducers: {
        setSliceInputImageInfo: (state, action) => {
            state.inputImageInfo = action.payload;
        },
    },
});

export const { setSliceInputImageInfo } = FJSliceObjectErase.actions;

export default FJSliceObjectErase.reducer;
